import axios from "axios";
// import { toast } from "react-toastify";

export const ApiPesquisa = axios.create({
  baseURL: process.env.REACT_APP_PESQUISA_API_URL,
  headers: {
    "Content-type": "application/json; charset=UTF-8",
  },
});

// ApiPesquisa.interceptors.request.use((config) => {
//   let token = "";
//   if (typeof window !== "undefined") {
//     const localToken = localStorage.getItem("@token");

//     if (localToken) {
//       token = localToken.replaceAll('"', "");
//     }

//     if (token && config.headers !== undefined) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//   }

//   return config;
// });

// ApiPesquisa.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response.status === 401) {
//       toast.error("Token expirado");
//       setTimeout(() => {
//         localStorage.clear();
//         window.location.href = "/agendamento/login";
//       }, 1500);
//     }

//     return Promise.reject(error);
//   }
// );
